import { createSelector } from '@reduxjs/toolkit';

const selectSimulations = (entities) => entities.simulations;

export const selectSimulationsResult = createSelector(
  [selectSimulations],
  (simulations) => simulations.simulationsResult,
);
